import axiosClient from "@/libs/axiosClient";

export const checkDocumentExist = options => {
    const params = new URLSearchParams({
        topic: options.topic,
        fieldVal: options.fieldVal,
        t: new Date().getTime()
    });

    if (options.crossGroup !== undefined) {
        params.set("crossGroup", options.crossGroup);
    }
    // 不檢查undefined，保持與既有行為一致，避免影響既有功能
    params.set("groupName", Array.isArray(options.groupName) ? options.groupName.join(",") : options.groupName);

    return axiosClient.get(`/validate/documentexist?${params.toString()}`);
};



// WEBPACK FOOTER //
// ./src/api/documentexist.js